import apiService from './apiService';
import API_BASE_URL from '../config/api';

const toQuery = (params = {}) => {
  const query = new URLSearchParams(
    Object.entries(params).filter(([, v]) => v !== undefined && v !== null && v !== '')
  ).toString();
  return query ? `?${query}` : '';
};

// PDF letöltés: az apiService JSON-t vár, ezért itt közvetlen fetch kell (401-nél egy token-frissítéssel)
const downloadPdf = async (endpoint, fallbackName, isRetry = false) => {
  const response = await fetch(`${API_BASE_URL}${endpoint}`, {
    headers: { Authorization: `Bearer ${apiService.getToken()}` },
    credentials: 'include',
  });

  if (response.status === 401 && !isRetry && (await apiService.refreshAccessToken())) {
    return downloadPdf(endpoint, fallbackName, true);
  }
  if (!response.ok) {
    let message = 'A PDF letöltése sikertelen.';
    try {
      message = (await response.json()).message || message;
    } catch (e) { /* nem JSON válasz */ }
    throw new Error(message);
  }

  const blob = await response.blob();
  const disposition = response.headers.get('Content-Disposition') || '';
  const fileName = disposition.match(/filename="([^"]+)"/)?.[1] || fallbackName;
  const url = URL.createObjectURL(blob);
  const link = document.createElement('a');
  link.href = url;
  link.download = fileName;
  document.body.appendChild(link);
  link.click();
  link.remove();
  URL.revokeObjectURL(url);
};

const billingService = {
  getProfile: () => apiService.get('/billing/profile'),
  updateProfile: (data) => apiService.put('/billing/profile', data),
  getMyInvoices: (params) => apiService.get(`/billing/invoices${toQuery(params)}`),
  downloadMyInvoicePdf: (invoice) => downloadPdf(`/billing/invoices/${invoice.id}/pdf`, `szamla-${invoice.id}.pdf`),
  payMyInvoice: (id) => apiService.post(`/billing/invoices/${id}/pay`),

  adminGetInvoices: (params) => apiService.get(`/billing/admin/invoices${toQuery(params)}`),
  adminRetryInvoice: (id, force = false) => apiService.post(`/billing/admin/invoices/${id}/retry`, { force }),
  adminDownloadInvoicePdf: (invoice) => downloadPdf(`/billing/admin/invoices/${invoice.id}/pdf`, `szamla-${invoice.id}.pdf`),
  adminMarkInvoicePaid: (id, paidAt) => apiService.post(`/billing/admin/invoices/${id}/mark-paid`, paidAt ? { paidAt } : {}),
  adminRunMonthlyCommission: () => apiService.post('/billing/admin/monthly-commission/run'),
  adminCancelInvoice: (id, { reason, refund, waiveCommission }) =>
    apiService.post(`/billing/admin/invoices/${id}/cancel`, { reason, refund, waiveCommission }),
};

export const INVOICE_TYPE_LABELS = {
  FEATURED_SUBSCRIPTION: 'Előfizetés / kiemelés',
  BOOKING_COMMISSION: 'Foglalási jutalék',
  MONTHLY_COMMISSION: 'Havi jutalék',
};

export const INVOICE_STATUS_LABELS = {
  PENDING: { label: 'Kiállítás alatt', color: 'default' },
  ISSUING: { label: 'Ellenőrizendő', color: 'warning' },
  ISSUED: { label: 'Kiállítva', color: 'success' },
  FAILED: { label: 'Hibás', color: 'error' },
  CANCELLED: { label: 'Sztornózva', color: 'default' },
};

export const formatHuf = (value) => `${Math.round(Number(value) || 0).toLocaleString('hu-HU')} Ft`;

export default billingService;
